import gsap from "@lib/gsap";
import { Scroll } from "@lib/scroll";

const defaults = {
  ease: "expo.out",
  duration: 1,
};

export default class PixelGrid {
  grid: HTMLElement | null;
  mainPage: HTMLElement | null;
  currentTl: gsap.core.Timeline | null;
  constructor() {
    this.grid = document.querySelector("[data-module='pixel-grid']");
    this.mainPage = document.querySelector("[data-taxi]");
    this.currentTl = null;
  }

  init() {
    gsap.set(this.grid, {
      display: "block",
      clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
    });
    // new Array(96).fill(0).forEach((_, index) => {
    //   const pixel = document.createElement("div");
    //   pixel.classList.add("pixel_grid_item");
    //   pixel.setAttribute("data-index", index.toString());
    //   this.grid?.appendChild(pixel);
    // });
  }

  stopScroll() {
    Scroll.stop();

    gsap.set(document.body, {
      height: "100vh",
      overflow: "hidden",
      // top: -Scroll.currentScroll,
      position: "relative",
    });

    gsap.set(this.mainPage, {
      height: "100%",
    });
  }

  startScroll() {
    Scroll.start();
    Scroll.toTop();
    this.resetScrollPosition();
  }

  async animateIn() {
    const { grid, mainPage } = this;
    // this.stopScroll();
    this.init();

    if (this.currentTl) {
      this.currentTl.kill();
    }

    const tl = gsap.timeline({
      paused: true,
      defaults,
    });

    this.currentTl = tl;

    tl.to(mainPage, {
      y: "-100px",
      opacity: 0.25,
      onComplete: () => {
        this.startScroll();
      },
    });

    tl.to(
      grid,
      {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      },
      "<"
    );

    tl.play();

    await new Promise((resolve) =>
      setTimeout(resolve, defaults.duration * 1000)
    );
  }

  animateOut() {
    const { grid, mainPage } = this;

    gsap.set(mainPage, { y: "100px" });

    if (this.currentTl) {
      this.currentTl.kill();
    }

    const tl = gsap.timeline({
      paused: true,
      defaults,
      onComplete: () => {
        this.resetScrollPosition();
      },
    });

    this.currentTl = tl;

    tl.to(
      mainPage,
      {
        y: "0%",
        opacity: 1,
      },
      "<"
    );

    tl.to(
      grid,
      {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
      },
      "<"
    );

    tl.play();
  }

  resetScrollPosition() {
    const { mainPage } = this;
    document.body.style.removeProperty("height");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");

    mainPage?.style.removeProperty("transform");
    mainPage?.style.removeProperty("opacity");
    mainPage?.style.removeProperty("translate");
    mainPage?.style.removeProperty("scale");
    mainPage?.style.removeProperty("height");
    mainPage?.style.removeProperty("rotate");
  }
}
